module.exports = __webpack_public_path__ + "img/04.016f7da3.png";